export default __webpack_public_path__ + "static/media/teach-1.d4cc1936.png";